import React from "react";
import { motion } from "framer-motion";
import Footer from './Footer'
import eq from '../assets/eq1.png'
import ai from '../assets/ai_study_buddy.png'
import eld from '../assets/eld.png'
import CC from '../assets/CC.png'

const ProjectCard = ({ image, title, description, git, technologies, link, index }) => {
    return (
        <motion.div 
            className="max-w-sm bg-gray-900 border rounded-lg shadow sm:max-w-sm md:max-w-sm border-neutral-100 dark:bg-gray-800 dark:border-gray-700"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ scale: 1.03, y: -5 }}
        >
            <a href={link ? link : "#"} target={link ? "_blank" : undefined} rel={link ? "noopener noreferrer" : undefined}>
                <motion.img 
                    className="object-cover w-full h-auto rounded-t-lg" 
                    src={image} 
                    alt={title}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                />
            </a>
            <div className="p-4 sm:p-6">
                <a href={link ? link : "#"} target={link ? "_blank" : undefined} rel={link ? "noopener noreferrer" : undefined}>
                    <h5 className="text-2xl font-bold tracking-tight text-transparent text-white sm:text-xl md:text-2xl lg:text-3xl bg-clip-text bg-gradient-to-r from-yellow-200 to-pink-500">{title}</h5>
                </a>
                <p className="text-sm font-normal text-gray-300 sm:text-base md:text-lg dark:text-gray-400">{description}</p>
            </div>
            <div className='flex justify-between m-2 sm:m-4 lg:m-6'>
                <div className='flex flex-wrap gap-2 pl-2'>
                    {technologies.map((tag, index) => (
                        <motion.p
                            key={`${index}-${tag}`}
                            className='text-[14px] text-blue-500'
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.3, delay: index * 0.05 }}
                        >
                            #{tag}
                        </motion.p>
                    ))}
                </div>
                <motion.a 
                    href={git} 
                    className="p-1 text-red-300 duration-300 border border-gray-200 rounded-lg shadow sm:p-2 lg:p-3 hover:text-green-500" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                >
                    GitHub
                </motion.a>
            </div>
        </motion.div>
    );
};
  
const Projects = () => {
    return (
        <div className="bg-black">
            <motion.div 
                className="flex flex-wrap items-center justify-center p-12 m-12 gap-7"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                {project.map((item, index) => (
                    <ProjectCard
                        key={index}
                        index={index}
                        image={item.image}
                        title={item.title}
                        description={item.description}
                        links={item.links}
                        git={item.git}
                        technologies={item.technologies}
                        link={item.link}
                    />
                ))}
            </motion.div>
            <Footer/>
        </div>
    );
}


export const project = [
    {
        title:'EQUISPLIT',
        description:'EQUISPLIT is a web-based bill-splitting application designed to simplify group expense management. It enables users to effortlessly split bills, track expenses, and calculate individual contributions.',
        image: eq,
        git:'https://github.com/Pranavlol7/EQUISPLIT',
        technologies:['MongoDB' ,'ReactJS' , 'NodeJS']
    },
    {
        title:'AI Study Buddy',
        description:'AI Study Buddy is a web application that leverages the power of DeepSeek R1 Turbo model to provide personalized study assistance. It offers features like free and useful resources generation, youtube video suggestions, and study material summarization.',
        image: ai,
        technologies:[ 'React JS', 'Node JS', 'MongoDB'],
        git:'https://github.com/Pranav3460/AI-Study-Buddy',
        link: 'https://ai-study-buddy.netlify.app/'
    },
    {
        title : 'Trip ELD Planner',
        description : 'Trip ELD Planner is a web application designed to assist truck drivers in planning their trips efficiently while adhering to the regulations set by the Federal Motor Carrier Safety Administration (FMCSA). The application helps drivers optimize their routes, manage their hours of service (HOS), and ensure compliance with ELD mandates.',
        image : eld,
        technologies : ['ReactJS', 'Django', 'PostgreSQL'],
        git : 'https://github.com/Pranav3460/Trip-ELD-Planner',
        link : 'https://trip-eld-planner.vercel.app/'
    },
    {
        title:'CampusConnect',
        description:'A cross-platform mobile app built to streamline academic communication and daily campus activities. CampusConnect connects students and faculty through real-time notices, resource sharing, and interactive community features.',
        image: CC,
        technologies:['React Native' ,'Firebase' , 'NodeJS', 'Express','ExpoGo',],
        git:'https://github.com/AmanShukla18/Campus_Connect-Major_Project',
        link:'https://campus-connect-major-project.onrender.com/'
    },
]

export default Projects
//npm run build then firebase deploy --only hosting